import { getScript } from 'js/utils/scripts.util';
import { useCallback } from 'react';

import * as Types from '../../../types';

export const useXpointLiteDownloadSDK = ({
    sdkUrl
}: {
    sdkUrl: string;
}) => {
    return useCallback(async () => {
        if (!window.xpoint) {
            await getScript(sdkUrl);
        }

        return window.xpoint!.WebSdkLite!.getInstance({
            checkStatusPositionOptions: {
                timeout: 15 * 1000,
                maximumAge: 60 * 60 * 1000,
                enableHighAccuracy: true
            },
            watchPositionOptions: {
                timeout: 60 * 1000,
                maximumAge: 300 * 1000,
                enableHighAccuracy: true
            }
        }) as Types.GeofencingSdkInstance;
    }, [sdkUrl]);
};
